import { AutorenewIcon, Button } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './generateButton.module.scss';

export const GenerateButton = ({ onGenerateClick, isLoading, isGalleryDisplayed }) => {
    return !isGalleryDisplayed ? (
        <Button onClick={onGenerateClick} disabled={isLoading} size="sm" className={styles['button']}>
            <FormattedMessage
                id="creative.editor.tab.aiGenerated.imageToMotion.button.generate"
                defaultMessage="Generate Motion"
            />
        </Button>
    ) : (
        <Button onClick={onGenerateClick} disabled={isLoading} size="sm" variant="outline" className={styles['button']}>
            <AutorenewIcon />
            <FormattedMessage
                id="creative.editor.tab.aiGenerated.imageToMotion.button.generateMore"
                defaultMessage="Generate more"
            />
        </Button>
    );
};
